module.exports = __webpack_public_path__ + "static/slider-img-one-6c3b0b5f707f8f552e0c04ae5d0248f4.jpg";